module.exports = __webpack_public_path__ + "img/send-file.1357984c.svg";